module.exports = __webpack_public_path__ + "static/media/tablet.c41a997b.png";